import { Injectable } from '@angular/core';

import { Query, Store, StoreConfig } from '@datorama/akita';
import { map } from 'rxjs';

import { Domain } from '@common/types';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'domain', resettable: true })
export class DomainState extends Store<Domain> {
  constructor() {
    super({});
  }
}

@Injectable({ providedIn: 'root' })
export class DomainQuery extends Query<Domain> {
  constructor(protected domainState: DomainState) {
    super(domainState);
  }

  domain$ = this.select();
  logo$ = this.select('config').pipe(map((config) => config?.logo));
  companyName$ = this.select('company_name');
}
